export const JA_INQUIRY_PLACEHOLDER = `メッセージをご利用下さい
土日祝日に頂きましたお問い合わせは、翌営業日（平日9：30～17：30）に順次回答させて頂きます。
お急ぎのお問合せは直接ホテル（+62-361-702-222）までお電話にてご連絡ください。`;
